import { FactoryVersion } from '@nominex/nomiswap-sdk'

const useFactoryVersionFromURL = (): FactoryVersion => {
  const searchParams = new URLSearchParams(window.location.search)
  const version = Number(searchParams.get('version'))

  if (Object.values(FactoryVersion).some((value) => !Number.isNaN(Number(value)) && version === value)) {
    return version
  }

  return FactoryVersion.V1
}

export default useFactoryVersionFromURL
